import { ReactNode } from "react";
import styled from "@emotion/styled";
import { Button, Card, Space } from "antd";
import { useBookingWizard } from "../../contexts/BookingWizardContext";
import { useTranslation } from "react-i18next";

const StepContainer = styled(Card)`
  max-width: 800px;
  margin: 20px auto;
`;

const Footer = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
`;

export interface WizardStepProps {
  children: ReactNode;
  onNext?: () => void;
  onPrevious?: () => void;
  isLastStep?: boolean;
  nextButtonText?: string;
  nextDisabled?: boolean;
  footerContent?: ReactNode;
}

export const WizardStep = ({
  children,
  onNext,
  onPrevious,
  isLastStep,
  nextButtonText,
  nextDisabled,
  footerContent,
}: WizardStepProps) => {
  const { state } = useBookingWizard();
  const { t } = useTranslation();
  const isSubmitted = state.status === "submitted";

  return (
    <StepContainer>
      <div style={{ marginBottom: 24 }}>{children}</div>
      <Footer>
        {footerContent && (
          <div style={{ textAlign: "left", maxWidth: 480 }}>
            {footerContent}
          </div>
        )}
        <Space>
          {onPrevious && (
            <Button onClick={onPrevious} disabled={isSubmitted}>
              {t("common.previous")}
            </Button>
          )}
          {onNext && (
            <Button
              type="primary"
              onClick={onNext}
              disabled={isSubmitted || nextDisabled}
            >
              {nextButtonText ||
                (isLastStep ? t("common.submit") : t("common.next"))}
            </Button>
          )}
        </Space>
      </Footer>
    </StepContainer>
  );
};
